module.exports = __webpack_public_path__ + "media/images/athletes/3458-a59b246c288b163c3f6e5fa43944b4d0.png";